import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { MobileStepper, Paper, Typography, Button, Card, CardContent } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'
import SwipeableViews from 'react-swipeable-views'
import { ManualText01, ManualText02, ManualText03, ManualText04, ManualText05 } from './ManualTexts'

const tutorialSteps = [
  {
    label: '受講生一覧ページ（Users）',
    imgPath: 'https://materials.englishcompany.jp/images/manual-index.png',
    text: ManualText01,
  },
  {
    label: '動画一覧（Videos）',
    imgPath: 'https://materials.englishcompany.jp/images/manual-videos.png',
    text: ManualText02,
  },
  {
    label: '音声一覧（Audios）',
    imgPath: 'https://materials.englishcompany.jp/images/manual-audios.png',
    text: ManualText03,
  },
  {
    label: 'ユーザー新規登録（User Register）',
    imgPath: 'https://materials.englishcompany.jp/images/manual-register.png',
    text: ManualText04,
  },
  {
    label: 'モバイル端末での音声ダウンロードについて',
    imgPath: null,
    text: ManualText05,
  },
]

// Style
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 1200,
    flexGrow: 1,
    margin: '0 auto',
  },
  alert: {
    width: '40%',
    margin: '1rem 0 2rem 0',
    letterSpacing: '.8pt',
  },
  contents: {
    border: '1px solid rgba(0,0,0,0.12)',
    borderRadius: '4px',
  },
  card: {
    boxShadow: 'none',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 50,
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
    border: '1px solid #eeeeee',
  },
  typo: {
    letterSpacing: '.8pt',
  },
  img: {
    display: 'block',
    maxWidth: 1200,
    overflow: 'hidden',
    width: '100%',
    margin: '2rem 0'
  },
  stepper: {
    maxWidth: 700,
    margin: '0 auto',
  }
}))

export default function Manual() {
  const classes = useStyles()
  const theme = useTheme()
  const [alertFlag, setAlertFlag] = useState(true)

  const [activeStep, setActiveStep] = useState(0)
  const maxSteps = tutorialSteps.length

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1)
  }

  const handleStepChange = step => {
    setActiveStep(step)
  }

  return (
    <div className={classes.root}>
      {alertFlag && (
        <Alert
          severity="info"
          className={classes.alert}
          onClose={() => setAlertFlag(false)}
        >
          ドラッグ&ドロップで左右にスライドできます
        </Alert>
      )}

      <div className={classes.contents}>
        <Paper square elevation={0} className={classes.header}>
          <Typography variant="h6">{tutorialSteps[activeStep].label}</Typography>
          <Typography>EC受講生専用サイト マニュアル （{activeStep + 1}）</Typography>
        </Paper>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {tutorialSteps.map((step, index) => (
            <div key={step.label}>
              {Math.abs(activeStep - index) <= 2 ? (
                <>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="div"
                        dangerouslySetInnerHTML={{ __html: step.text }}
                        className={classes.typo}
                      />
                    </CardContent>
                  </Card>
                  {step.imgPath && (
                    <img className={classes.img} src={step.imgPath} alt={step.label} />
                  )}
                </>
              ) : null}
            </div>
          ))}
        </SwipeableViews>
      </div>

      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="progress"
        activeStep={activeStep}
        className={classes.stepper}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
        }
      />
    </div>
  )
}

if (document.getElementById('manual')) {
  ReactDOM.render(
    <Manual />,
    document.getElementById('manual')
  )
}